import { FormControl, FormGroup, MenuItem, Select, Stack, Typography } from '@mui/material'
import { SelectOption } from '@operations/app/models'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { defaultValues, HatchcoverFilter } from '../../models/hatchcover-filters.model'

interface Props {
  id?: string
  equipmentOptions: SelectOption[]
  filter?: HatchcoverFilter | null
  onSubmit: (formValues: HatchcoverFilter) => Promise<void> | void
}

export const HatchCoverMoveFilterForm = observer(
  ({ id, equipmentOptions, onSubmit, filter }: Props) => {
    const { t } = useTranslate()
    const theme = useMinimalsTheme()
    const { handleSubmit, control, reset } = useForm<HatchcoverFilter>({
      defaultValues: defaultValues,
    })

    useEffect(() => {
      if (filter) {
        reset(filter)
      }
    }, [filter, reset])

    const directionOptions: SelectOption[] = [
      { label: t('open', 'Open'), value: 'open' },
      { label: t('close', 'Close'), value: 'close' },
    ]
    return (
      <Stack
        gap={theme.customSpacing.m}
        id={id}
        component={'form'}
        noValidate
        autoComplete='off'
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormGroup sx={{ gap: theme.customSpacing.xs }}>
          <Typography variant='subtitle2'>{t('direction', 'Direction')}</Typography>
          <FormControl>
            <Controller
              control={control}
              name='direction'
              render={({ field }) => (
                <Select
                  {...field}
                  fullWidth
                  onChange={event => {
                    field.onChange(event.target.value)
                  }}
                >
                  {directionOptions.map(direction => (
                    <MenuItem key={direction.value} value={direction.value}>
                      {direction.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
        </FormGroup>

        <FormGroup sx={{ gap: theme.customSpacing.xs }}>
          <Typography variant='subtitle2'>{t('equipment', 'Equipment')}</Typography>
          <FormControl>
            <Controller
              control={control}
              name='equipmentName'
              render={({ field }) => (
                <Select
                  {...field}
                  fullWidth
                  onChange={event => {
                    field.onChange(event.target.value)
                  }}
                >
                  {equipmentOptions.map(equipment => (
                    <MenuItem key={equipment.value} value={equipment.value}>
                      {equipment.label}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
          </FormControl>
        </FormGroup>
      </Stack>
    )
  },
)
